import { createFrontendModule, NotFoundErrorPage } from '@backstage/frontend-plugin-api';
import { SwappableComponentBlueprint } from '@backstage/plugin-app-react';
import { ErrorPage } from '@backstage/core-components';
import { Navigate, useLocation } from 'react-router-dom';

// Primeiro acesso: quem entra por um link que não existe (ou pela raiz do site)
// cai na Home, não numa tela de erro. Já dentro do portal, uma página que não
// existe continua mostrando o erro 404 de verdade.
//
// "Primeiro acesso" = a URL com que a página foi aberta (capturada quando este
// módulo carrega, antes do login). A tela de login aparece NO LUGAR dessa URL e,
// depois do login, o Backstage desenha a rota dela: se a rota não existe, cai
// aqui. Se for a mesma URL de entrada, vai para /home (com replace, para o
// "voltar" do navegador não voltar para a URL quebrada); qualquer outra URL
// inexistente é navegação dentro do portal e mostra o 404.
//
// A raiz "/" é tratada por um redirecionamento em app-config.local.yaml
// (app/routes -> redirects), mais direto que passar por aqui.
const ENTRY_URL =
  typeof window === 'undefined'
    ? ''
    : `${window.location.pathname}${window.location.search}${window.location.hash}`;

function LandingNotFound() {
  const { pathname, search, hash } = useLocation();
  if (`${pathname}${search}${hash}` === ENTRY_URL) {
    return <Navigate to="/home" replace />;
  }
  return <ErrorPage status="404" statusMessage="Página não encontrada" />;
}

// Mesmo "name" da extensão original do plugin 'app' (core-not-found-error-page):
// só assim ela é SUBSTITUÍDA. Com outro nome as duas conviveriam e o Backstage
// ficaria com a que aparecer por último, sem ordem garantida.
const notFoundOverride = SwappableComponentBlueprint.make({
  name: 'core-not-found-error-page',
  params: define =>
    define({
      component: NotFoundErrorPage,
      loader: () => LandingNotFound,
    }),
});

// pluginId 'app': a tela de "não encontrada" é do plugin de núcleo (mesmo motivo
// de a SignInPage ser sobrescrita em App.tsx).
export const landingModule = createFrontendModule({
  pluginId: 'app',
  extensions: [notFoundOverride],
});
